import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import FooterSection from "../components/UI/FooterSection";
import ReactDatatable from "@ashvin27/react-datatable";
import BusinessUserSideBar from "../components/container/SideBar";
import ClientSideBar from "../components/container/layout/client/SideBar";
import Header from "../components/container/layout/pharmacy/Header";
import InputField from "../components/UI/InputField";
import axios from "axios";
import { Popup } from "../components/UI/Popup";
import { Spinner } from "../components/UI/Spinner";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Label from "../components/UI/Label";
import {
  getAllMasterDrug,
  getAllPharmacyDrugs,
  getAllDrugTypes,
  getAllDrugCategories,
  addPharmacyDrug,
  updatePharmacyDrug,
  deletePharmacyDrug,
  searchDrug,
  getAllDrugMeasures,
  getTimeoutbycategory,
  pharmacydrugimport
} from "../config/url.json";
import { CONFIG } from "../config/data";
import Select from "react-select";
import Validation from "../actions/Validation";
import SpanField from "../components/UI/SpanField";
import { Button, Modal, ModalHeader, ModalBody } from "reactstrap";
// Import React Table
import "react-table/react-table.css";
import IdleTimer from 'react-idle-timer';
import { IdleTimeOutModal } from '../components/container/modal/IdleModal';
import ExpirePopup from "../components/UI/ExpirePopup"
import Tooltip from '@mui/material/Tooltip';
import DrugsExport from "./DrugsExport";
import DrugTemplate from "./DrugTemplate";
import LoadingSpinner from "../components/UI/LoadingSpinner";
import LoadingHeartrate from "../components/UI/Heartrate";
import readXlsxFile from 'read-excel-file';
import { Popupinfo } from "../components/UI/Popupinfo";
import Dnaspinner from "../components/UI/Dnaspinner";


function mapStateToProps(state) {
  return {
    appdata: state.AppData,
    userdata: state.AuthReducer.user,
    access_token: state.AuthReducer.access_token,
    validity: state.ValidityReducer.validity
  };
}
function mapDispatchToProps(dispatch) {
  return {
    logout: () => dispatch({ type: "SET_LOGOUT" }),
  };
}


class PharmacyDrugslist extends Component {
  constructor(props) {
    super(props);
    this.idleTimer = React.createRef()
    const hospitaltimeout = this.state;

    this.state = {
      adminstatus: this.props.userdata.adminstatus,
      showexpirePopup: this.props.validity,
      timeout: hospitaltimeout,
      isTimedOut: false,
      showModal: false,

      records: [],

      searchrecords: [],
      drug_action: "Add",
      loading: false,
      addDrugSuccess: "",
      showDeleteConfirmPopup: false,
      confirmedDelete: false,
      search_action: false,
      recordToDelete: [],
      drugTypes: [],
      drugCategories: [],
      masterdrugNames: [],
      newDatatoAdd: {},
      addPopup: false,
      formSuccess: {
        message: "",
        status: "",
    },
      drugList: {
        s_no: "",
        drug_id: "",
        drug_name: "",
        drug_category: "",
        drug_type: "",
        manufacturer: "",
        active_ingredients: "",
      },
      drugData: {
        id: "",
        drug_id: "",
        searchdrug_id:"",
        manufacturer: "",
        drug_name: "",
        generic_name:"",
        drug_type: "",
        drug_category: "",
        active_ingredients: "",
        unit_of_measure: "",
      },
      errors: {
        drug_id: "",
        drug_name: "",
        drug_type: "",
        drug_category: "",
        unit_of_measure: "",
        generic_name:"",
        active_ingredients: "",
        manufacturer:"",
      },
      searchData: {
        drug_name: "",
        drug_category: "",
        drug_type: "",
        generic_name:"",
        manufacturer: "",
        active_ingredients: "",
      },
      tableSuccess: {
        message: "",
        status: "",
      },
      formSuccess: {
        message: "",
        status: "",
      },
      editformSuccess: {
        message: "",
        status: "",
      },
      searchTableSuccess: {
        message: "",
        status: "",
      },
      columns: [
        { title: "Drug Id", field: "drug_id" },
        { title: "Drug Name", field: "drug_name" },
        { title: "Drug Category", field: "drug_category" },
        { title: "Drug Type", field: "drug_type" },
        { title: "Manufacturer", field: "manufacturer" },
        { title: "Active Ingredients", field: "active_ingredients" },
      ],
      data: [
        {
          drug_id: "1",
          drug_name: "da",
          drug_category: "ds",
          drug_type: "sdd",
          manufacturer: "sdsd",
          active_ingredients: "adsfd",
        },
      ],
      searchErrorMessage: "",
    };
    this.columns = [
      {
        key: "s_no",
        text: "S.No",
        className: "s_no",
        align: "left",
        sortable: true,
        width: 10,
      },
      // {
      //   key: "drug_id",
      //   text: "Drug ID",
      //   className: "drug_id",
      //   align: "left",
      //   sortable: true,
      //   width: 100,
      // }, 
      {
        key: "drug_name",
        text: "Drug Name",
        className: "drug_name",
        align: "left",
        sortable: true,
        width: 200,
      },
      /* {
        key: "generic_name",
        text: "Generic Name",
        className: "generic_name",
        sortable: true,
        align: "left",
        width: 100,

      
      }, */
      /*       {
              key: "drug_category",
              text: "Drug Category",
              className: "drug_category",
              sortable: true,
              align: "left",
              width: 100,
            },
      
            {
              key: "drug_type",
              text: "Drug Type",
              className: "drug_type",
              sortable: true,
              align: "left",
              width: 100,
            },
       */
     /*  {
        key: "manufacturer",
        text: "Manufacturer",
        className: "manufacturer",
        sortable: true,
        align: "left",
        width: 100,
      }, */

      {
        key: "active_ingredients",
        text: "Active Incredients",
        className: "active_ingredients",
        sortable: true,
        align: "left",
        width: 200,
      },
     /*  {
        key: "unit_of_measure",
        text: "Unit of Measure",
        className: "unit_of_measure",
        sortable: true,
        align: "left",
        width: 100,
      }, */
      {
        key: "action",
        text: "Action",
        className: "action",
        width: 20,
        align: "left",
        sortable: false,
        cell: (record) => {
          return (
            <Fragment>
                 <Tooltip title="Edit">
              <button
                className="btn btn-primary btn-sm"
                onClick={() => this.editRecord(record)}
                style={{ marginRight: "5px" }}
              >
                <i className="fa fa-edit"></i>
              </button>
              </Tooltip>
              <Tooltip title="Delete">
              <button
                className="btn btn-danger btn-sm"
                onClick={() => this.onDeleteClick(record)}
              >
                <i className="fa fa-trash"></i>
              </button>
              </Tooltip>
            </Fragment>
          );
        },
      },
    ];
    this.config = {
      page_size: 10,
      length_menu: [10, 20, 50],
      button: {
        excel: false,
        print: false,
      },
    };
    this.searchconfig = {
      page_size: 10,
      length_menu: [10, 20, 50],
      button: {
        excel: false,
        print: false,
      },
    };

    this.searchcolumns = [
      // {
      //   key: "s_no",
      //   text: "S.No",
      //   className: "s_no",
      //   align: "left",
      //   sortable: true,
      // },
      {
        key: "drug_id",
        text: "Drug ID",
        className: "drug_id",
        align: "left",
        sortable: true,
        width: 10,
        cell: (record) => {
          // let obj = {
          //   label: record.availability,
          //   value: "Yes" === record.availability ? 1 : 0,
          // };
          return (
            <Fragment>
              <InputField
                inputType={"text"}
                isMandatory={true}
                name={"searchdrug_id"}
                controlFunc={this.handleInputsearch.bind(this, record)}
                content={record.searchdrug_id}
                placeholder={""}
                max={5}
              />
              <SpanField classname="text-danger" title={record.drugid_error} />
            </Fragment>
          );
        },
      },
      {
        key: "drug_name_hide",
        text: "drug_name_hide",
        className: "drug_name hide",
        TrOnlyClassName: "hide",
        align: "left",
        sortable: true,
        width: 100,
      },
    /*   {
        key: "drug_category_hide",
        text: "drug_category_hide",
        className: "drug_category_hide hide",
        TrOnlyClassName: "hide",
        align: "left",
        sortable: true,
        width: 100,
      },
      {
        key: "drug_type_hide",
        text: "drug_type_hide",
        className: "drug_type_hide hide",
        TrOnlyClassName: "hide",
        align: "left",
        sortable: true,
        width: 100,
      },
     */  {
        key: "unit_of_measure_hide",
        text: "unit_of_measure_hide",
        className: "unit_of_measure_hide hide",
        TrOnlyClassName: "hide",
        align: "left",
        sortable: true,
        width: 100,
      },
      {
        key: "drug_name",
        text: "Drug Name",
        className: "drug_name",
        align: "left",
        sortable: true,
        width: 100,

        // cell: (record) =>
        //  {
        //   return (
        //     <Fragment>

        /* <InputField
          inputType={"text"}
           isMandatory={true}
            name={"drug_name"}
            controlFunc={this.handleInput.bind(this)}
            content={record.drug_name.label}
             placeholder={""}
             max={50}
             />
              */
        //       <SpanField
        //         classname="text-danger"
        //         title={record.drugname_error}
        //       />
        //     </Fragment>
        //   );
        // },
      },
      {
        key: "generic_name",
        text: "Generic Name",
        className: "generic_name",
        sortable: true,
        align: "left",
        width: 100,

      
      },
      {
        key: "unit_of_measure",
        text: "Unit of Measure",
        className: "unit_of_measure",
        align: "left",
        sortable: true,
        width: 100,

        // cell: (record) => {
        //   return (
        //     <Fragment>
           
        //       <InputField
        //         inputType={"text"}
        //         isMandatory={true}
        //         name={"unit_of_measure"}
        //         controlFunc={this.handleInputsearch.bind(this, record)}
        //         content={record.unit_of_measure ? record.unit_of_measure.label : ""}
        //         placeholder={""}
        //         max={50}
        //       />

        //       <SpanField
        //         classname="text-danger"
        //         title={record.measure_error}
        //       />
        //     </Fragment>
        //   );
        // },

      },

    /*   {
        key: "drug_category",
        text: "Drug Category",
        className: "drug_category",
        sortable: true,
        align: "left",
        width: 100,

      },

      {
        key: "drug_type",
        text: "Drug Type",
        className: "drug_type",
        sortable: true,
        align: "left",
        width: 100,

      
      },
 */
      {
        key: "manufacturer",
        text: "Manufacturer",
        className: "manufacturer",
        sortable: true,
        align: "left",
        width: 20,

        // cell: (record) => {
        // let obj = {
        //   label: record.availability,
        //   value: "Yes" === record.availability ? 1 : 0,
        // };
        //   return (
        //     <InputField
        //       inputType={"text"}
        //       isMandatory={true}
        //       name={"manufacturer"}
        //       controlFunc={this.handleInput.bind(this)}
        //       content={record.manufacturer}
        //       placeholder={""}
        //     />
        //   );
        // },
      },

      {
        key: "active_ingredients",
        text: "Active Incredients",
        className: "active_ingredients",
        sortable: true,
        align: "left",
        width: 20,

        // cell: (record) => {
        // let obj = {
        //   label: record.availability,
        //   value: "Yes" === record.availability ? 1 : 0,
        // };
        //   return (
        //     <InputField
        //       inputType={"text"}
        //       isMandatory={true}
        //       name={"active_ingredients"}
        //       controlFunc={this.handleInput.bind(this)}
        //       content={record.active_ingredients}
        //       placeholder={""}
        //     />
        //   );
        // },
      },

      {
        key: "action",
        text: "Action",
        className: "action",
        width: 20,
        align: "left",
        sortable: false,
        cell: (record) => {
          return (
            <Fragment>
              <button
                className="btn btn-primary btn-sm"
                onClick={() => this.addRecord(record)}
                style={{ marginRight: "5px" }}
              >
                <i className="fa fa-plus"></i>
              </button>
              {/* <button
                className="btn btn-danger btn-sm"
                onClick={() => this.deleteRecord(record)}
              >
                <i className="fa fa-trash"></i>
              </button> */}
            </Fragment>
          );
        },
      },
    ];
    this.idleTimer = null
    this.onAction = this._onAction.bind(this)
    this.onActive = this._onActive.bind(this)
    this.onIdle = this._onIdle.bind(this)
    this.handleClose = this.handleClose.bind(this)
    this.handleLogout = this.handleLogout.bind(this)

  }
  handleClose() {
    this.setState({ showModal: false })
  }


  handleLogout = (e) => {
    this.setState({ showModal: false })
    e.preventDefault();
    localStorage.removeItem("token");
    this.props.logout();

  };

  _onAction(e) {
    console.log('user did something', e)

    this.setState({ isTimedOut: false })
  }

  _onActive(e) {

    console.log('user is active', e)
    this.setState({ isTimedOut: false })
  }

  _onIdle = (e) => {
    console.log('user is idle', e)
    let isTimedOut = this.state.isTimedOut
    let timeout = this.state.timeout;
    console.log(timeout);
    console.log(isTimedOut);
    if (isTimedOut===false) 
    {
     // console.log("the time is over");
      this.setState({showModal: true})
      console.log(this.state.showModal);
       this.idleTimer.reset();
       this.setState({isTimedOut: true})

    } 
  if(isTimedOut===true)
  {
    localStorage.removeItem("token");
    this.props.logout();
    
  }
  }
  handleCategoryColumnChange = (value, record, field) => {
    // console.log(field);
    // console.log(value);
    // console.log(record);
    value[field] = record;
    // console.log(record);
    // record.availability = "Yes" === record.availability ? "No" : "Yes";
    this.UpdateColumnChange(value);
  };
  handleInputsearch = (record, event) => {
    record[event.target.name] = event.target.value;
    let max = event.target.max;
    let value=event.target.value;
     if (
       event.target.name === "searchdrug_id"
 
     ) {
       if (value.length > max) {
         const value1 = value.slice(0, max);
         record.drugid_error  = "Maximum Length has exceeded.";
         record[event.target.name] = value1;
       }
      else {
       record.drugid_error  = "";
       record[event.target.name] = event.target.value;
     }
   }
    this.UpdateColumnChange(record);
  };
  UpdateColumnChange = (record) => {
    let records = this.state.searchrecords;
    var recIndex = findWithAttr(records, "id", record.id);
    records[recIndex].drug_id = record.drug_id;
    records[recIndex].drug_name = record.drug_name;
    records[recIndex].drug_category = record.drug_category;
    records[recIndex].drug_type = record.drug_type;

    this.setState({ searchrecords: records });
  };
  componentDidMount = () => {
    console.log(this.props.userdata.user_type);
    axios.defaults.headers.common[
      "Authorization"
    ] = `Bearer ${this.props.access_token}`;

    axios
      .post(getTimeoutbycategory, { category: this.props.userdata.user_type }, CONFIG)
      .then((res) => {
        let data = res.data;
        console.log(res);
        console.log(data);
        console.log(data.data.timeout);
        if (data.status === "1")
          this.setState({
            hospitaltimeout: data.data.timeout

          });
      })
      .catch(() => { });


    axios.defaults.headers.common[
      "Authorization"
    ] = `Bearer ${this.props.access_token}`;
    axios
      .post(getAllMasterDrug, "", CONFIG)
      .then((drugMasterRespons) => {
        let masterdrugNameList = drugMasterRespons.data.data;
        let masterdrugNames = [];
        masterdrugNameList.forEach((element) => {
          masterdrugNames.push({
            value: element.id,
            label: element.drug_name,
            manufacturer: "",
            active_incredient: "",
          });
        });

        this.setState({ masterdrugNames });
      })
      .catch(() => { });

    axios.defaults.headers.common[
      "Authorization"
    ] = `Bearer ${this.props.access_token}`;
    axios
      .post(getAllDrugTypes, { user_id: this.props.userdata.id }, CONFIG)
      .then((drugTypeResponse) => {
        let drugTypeList = drugTypeResponse.data.data;
        let drugTypes = [];
        drugTypeList.forEach((element) => {
          drugTypes.push({ value: element.id, label: element.drug_type });
        });

        this.setState({ drugTypes });
      })
      .catch(() => { });

    axios.defaults.headers.common[
      "Authorization"
    ] = `Bearer ${this.props.access_token}`;
    axios
      .post(getAllDrugCategories, { user_id: this.props.userdata.id }, CONFIG)
      .then((drugCategoryResponse) => {
        let list = drugCategoryResponse.data.data;

        let drugCategories = [];
        list.forEach((element) => {
          drugCategories.push({
            value: element.id,
            label: element.drug_category,
          });
        });
        this.setState({ drugCategories });
      })
      .catch(() => { });

    axios.defaults.headers.common[
      "Authorization"
    ] = `Bearer ${this.props.access_token}`;
    axios
      .post(getAllPharmacyDrugs, { user_id: this.props.userdata.id }, CONFIG)
      .then((list) => {
        let drugList = list.data.data;
        let drugDataArr = [];
        drugList.forEach((element, index) => {
          let drugData = {};
          drugData.s_no = index + 1;
          drugData.id = element.id;
          drugData.user_id = this.props.userdata.id;
          drugData.drug_id = element.drug_id;
          drugData.drug_name = element.drug_name;
          drugData.drug_type = element.drug_type;
          drugData.drug_category = element.drug_category;
          drugData.manufacturer = element.manufacturer;
          drugData.active_ingredients = element.active_ingredients;
          drugData.unit_of_measure = element.unit_of_measure;
          drugData.generic_name=element.generic_name;
          drugDataArr[index] = drugData;
        });

        this.setState({ records: drugDataArr });
      })
      .catch(() => { });


    axios
      .post(getAllDrugMeasures, "", CONFIG)
      .then((drugMasterRespons) => {
        let masterdrugmeasureList = drugMasterRespons.data.data;
        console.log(masterdrugmeasureList);
        let masterdrugmeasure = [];
        masterdrugmeasureList.forEach((element) => {
          masterdrugmeasure.push({
            value: element.unit_of_measure,
            label: element.unit_of_measure,

          });
        });

        this.setState({ masterdrugmeasure });
      })
      .catch(() => { });
  };
  addRecord = (record) => {
    let formvalid = true;
    if (record.searchdrug_id === "") {
      record.drugid_error = "Please enter drug id";
      formvalid = false;
    } else {
      record.drugid_error = "";
    }
    if (record.drug_name.label === "") {
      formvalid = false;
      record.drugname_error = "Please enter drug name";
    } else {
      record.drugname_error = "";
    }
    if(record.generic_name==="")
    {
      formvalid = false;
      record.generic_name_error = "Please enter generic name";
    } else {
      record.generic_name_error = "";
    }
    if (record.drug_category && record.drug_category.label === "") {
      formvalid = false;
      record.drugcategory_error = "Please enter drug category";
    } else {
      record.drugcategory_error = "";
    }
    if (record.drug_type && record.drug_type.label === "") {
      record.drugtype_error = "Please enter drug type";
      formvalid = false;
    } else {
      record.drugtype_error = "";
    }
    let records = this.state.searchrecords;
    var recIndex = findWithAttr(records, "id", record.id);
    records[recIndex] = record;
    this.setState({ searchrecords: records });
    if (formvalid) {
      this.setState({ drug_action: "Add" });
    //  this.setState({ newDatatoAdd: record, loading: true });
      // this.addorupdateDrug();

      axios.defaults.headers.common[
        "Authorization"
      ] = `Bearer ${this.props.access_token}`;

      let selectedData = record;
      // console.log(selectedData); return false;
      let data = {};
      data.user_id = this.props.userdata.id;
      data.drug_id = selectedData.searchdrug_id;
      data.drug_name = selectedData.drug_name;
      data.drug_type = selectedData.drug_type;
      data.drug_category = selectedData.drug_category;
      data.unit_of_measure = selectedData.unit_of_measure;
      data.manufacturer = selectedData.manufacturer;
      data.active_ingredients = selectedData.active_ingredients;
      data.generic_name=selectedData.generic_name;
      axios
        .post(addPharmacyDrug, data, CONFIG)
        .then((addDrugResponse) => {
          let res = addDrugResponse.data;
          console.log(addDrugResponse)
          if (res.status === "1") {
            let drug = {};
            let records = this.state.records;
            drug.s_no = this.state.records.length + 1;
            drug.drug_id = data.drug_id;
            drug.id = res.data[0].id;
            drug.drug_name = data.drug_name;
            drug.drug_category = data.drug_category;
            drug.unit_of_measure = data.unit_of_measure;
            drug.manufacturer = data.manufacturer;
            drug.drug_type = data.drug_type;
            drug.active_ingredients = data.active_ingredients;
            drug.generic_name=data.generic_name;
            records.push(drug);
            // this.setState({ searchrecords: records });
            this.setState({
              records: records,
              searchTableSuccess: res,
              loading: false,
            });
            toast.success("The Drug details have been added successfully. ", {
              className: "toast-success"
            });
            this.clearMessage();
            this.clearAll();
          } else {
            this.setState({
              searchrecords: records,
              searchTableSuccess: res,
              loading: false,
            });
            toast.error("Drug could not be Added. ", {
              className: "toast-error"
            });
            this.clearMessage();
          }
        })
        .catch(() => { });
    }
  };
  editRecord(record) {
    let drug_action = this.state.drug_action;
    drug_action = "Edit";
    this.setState({ drug_action });

    let drugData = this.state.drugData;
    drugData.s_no = record.s_no;
    drugData.id = record.id;
    drugData.drug_id = record.drug_id;
    drugData.drug_name = record.drug_name;
    // drugData.drug_name = {
    //   label: record.drug_name,
    //   value: record.drug_name,
    // };
    drugData.manufacturer = record.manufacturer;
    drugData.drug_type = {
      label: record.drug_type,
      value: record.drug_type,
    };
    drugData.drug_category = {
      label: record.drug_category,
      value: record.drug_category,
    };
    drugData.unit_of_measure = {
      label: record.unit_of_measure,
      value: record.unit_of_measure,
    };
    drugData.active_ingredients = record.active_ingredients;
    drugData.generic_name=record.generic_name;
    this.setState({ drugData: drugData });
  }

  handleselectChange = (selectedOptions, e) => {
    let data = this.state.drugData;
    let errors = this.state.errors;
    errors[e.name] = ""
    data[e.name] = selectedOptions;
    // if (e.name === "drug_name") {
    //   data.manufacturer = selectedOptions.manufacturer;
    //   data.active_ingredients = selectedOptions.active_ingredients;
    // }
    this.setState({ drugData: data, errors,searchErrorMessage: "" });
  };
  handlesearchinputChange = (eve) => {
    let data = this.state.searchData;

    data[eve.target.name] = eve.target.value;
    // }
    this.setState({ searchData: data });
  };
  handlesearchselectChange = (selectedOptions, e) => {
    let data = this.state.searchData;

    // if (e.name === "drug_name") {
    //   data.manufacturer = selectedOptions.manufacturer;
    //   data.active_ingredients = selectedOptions.active_ingredients;
    // } else {
    //   data[e.name] = selectedOptions;
    // }
    // if (e.name === "manufacturer" || e.name === "active_ingredients") {
    //   data[e.name] = selectedOptions.target.value;
    // } else {
    data[e.name] = selectedOptions;
    // }
    this.setState({ searchData: data });
  };
  validateMaxLength(name, value, max) {
    let data = this.state.drugData;
    let errors = this.state.errors;

    if (value.length > max) {
      const value1 = value.slice(0, max);
      errors[name] = "Maximum Length has exceeded.";
      data[name] = value1;
    } else {
      errors[name] = "";
      data[name] = value;
    }
    this.setState({ drugData: data, errors: errors });
  }
  handleInput = (e) => {
    let data = this.state.drugData;
    let errors = this.state.errors;
    let name = e.target.name;
    let value = e.target.value;
    let max = e.target.max;
    if (
      name === "drug_id" ||
      name === "drug_name" ||
      name === "manufacturer" ||
      name === "active_ingredients"||
      name === "generic_name"

    ) {
      this.validateMaxLength(name, value, max);
    } else {
      data[name] = value;
      errors[name] = ""
    }
    this.setState({ drugData: data, errors,searchErrorMessage: "" });
  };

  addorupdateDrug() {
    let url = this.state.drug_action === "Add" ? addPharmacyDrug : updatePharmacyDrug;
    axios.defaults.headers.common[
      "Authorization"
    ] = `Bearer ${this.props.access_token}`;


    let { drugData, errors } = this.state;
    drugData.type = "pharmacydrug";
    errors = Validation(drugData, errors);
    this.setState({ errors: errors });

    if (errors.formIsValid) {
      this.setState({ loading: true });

      let data = {};
     data.s_no = drugData.s_no;
      data.user_id = this.props.userdata.id;
      data.id = drugData.id;
     // data.drug_id = drugData.drug_id;
      data.drug_name = drugData.drug_name;
      //data.drug_type = drugData.drug_type.label;
      //data.unit_of_measure = drugData.unit_of_measure.label;
      //data.drug_category = drugData.drug_category.label;
    //  data.manufacturer = drugData.manufacturer;
      data.active_ingredients = drugData.active_ingredients;
     // data.generic_name=drugData.generic_name;
      let records = this.state.records;
      if (this.state.drug_action === "Add") {
        axios
          .post(url, data, CONFIG)
          .then((addDrugResponse) => {
            let res = addDrugResponse.data;
            console.log(res)
            if (res.status === "1") {
              let drug = {};

              drug.s_no = this.state.records.length + 1;
              drug.drug_id = data.drug_id;
              drug.id = res.data[0].id;
              drug.drug_name = data.drug_name;
             // drug.drug_category = data.drug_category;
             // drug.manufacturer = data.manufacturer;
             // drug.unit_of_measure = data.unit_of_measure;
           //   drug.generic_name=data.generic_name;
             // drug.drug_type = data.drug_type;
              drug.active_ingredients = data.active_ingredients;
              records.push(drug);
              // this.setState({ searchrecords: records });
              this.setState({
                records: records,
                searchTableSuccess: res,
                loading: false,
                editformSuccess: res,

              });
              toast.success("The Drug details have been added successfully.", {
                className: "toast-success"
              });
              this.clearMessage();
              this.clearAll();
            } else {
              this.setState({
                searchrecords: records,
                searchTableSuccess: res,
                editformSuccess: res,
                loading: false,
              });
              toast.error("Drug could not be Added. ", {
                className: "toast-error"
              });
              this.clearMessage();
            }
          })
          .catch(() => { });
      } else {
        axios
          .put(url, data, CONFIG)
          .then((updateDrugResponse) => {
            let updateResponse = updateDrugResponse.data;
            if (updateResponse.status === "1") {
              let addDrugSuccess = this.state.addDrugSuccess;
              addDrugSuccess = updateResponse.message;
              this.setState({ addDrugSuccess: addDrugSuccess });

              /** Updating the data table */
              let existingRecords = this.state.records;
              var index = existingRecords.findIndex(
                (item) => item.id === data.id
              );
              existingRecords.splice(index, 1, data);
              this.setState({ records: existingRecords });
               this.setState({ tableSuccess: updateResponse });
              this.setState({ editformSuccess: updateResponse });
              toast.success("The Drug details have been updated successfully.", {
                className: "toast-success"
              });
              this.clearMessage();
              this.clearAll();
            } else {
              this.setState({ tableSuccess: updateResponse });
              this.setState({ editformSuccess: updateResponse });
              toast.error("Drug could not be updated. ", {
                className: "toast-error"
              });
              this.clearMessage();
            }
            this.setState({ loading: false });
          })
          .catch(() => { });
      }
    }
  }


  // addorupdateDrug() {
  //   let url = this.state.drug_action === "Add" ? addPharmacyDrug : updatePharmacyDrug;
  //   axios.defaults.headers.common[
  //     "Authorization"
  //   ] = `Bearer ${this.props.access_token}`;


  //   let { drugData, errors } = this.state;
  //   drugData.type = "pharmacydrug";
  //   errors = Validation(drugData, errors);
  //   this.setState({ errors: errors });

  //   if (errors.formIsValid) {
  //     this.setState({ loading: true });

  //     let data = {};
     // data.s_no = drugData.s_no;
      // data.user_id = this.props.userdata.id;
      // data.id = drugData.id;
     // data.drug_id = drugData.drug_id;
      // data.drug_name = drugData.drug_name;
      //data.drug_type = drugData.drug_type.label;
      //data.unit_of_measure = drugData.unit_of_measure.label;
      //data.drug_category = drugData.drug_category.label;
    //  data.manufacturer = drugData.manufacturer;
      // data.active_ingredients = drugData.active_ingredients;
     // data.generic_name=drugData.generic_name;
      // let records = this.state.records;
      // if (this.state.drug_action === "Add") {
      //   axios
      //     .post(url, data, CONFIG)
      //     .then((addDrugResponse) => {
      //       let res = addDrugResponse.data;
      //       console.log(res)
      //       if (res.status === "1") {
      //         let drug = {};

      //         drug.s_no = this.state.records.length + 1;
      //         drug.drug_id = data.drug_id;
      //         drug.id = res.data[0].id;
      //         drug.drug_name = data.drug_name;
             // drug.drug_category = data.drug_category;
             // drug.manufacturer = data.manufacturer;
             // drug.unit_of_measure = data.unit_of_measure;
           //   drug.generic_name=data.generic_name;
             // drug.drug_type = data.drug_type;
              // drug.active_ingredients = data.active_ingredients;
              // records.push(drug);
              // this.setState({ searchrecords: records });
      //         this.setState({
      //           records: records,
      //           searchTableSuccess: res,
      //           loading: false,
      //           editformSuccess: res,

      //         });
      //         toast.success("The Drug details have been added successfully.", {
      //           className: "toast-success"
      //         });
      //         this.clearMessage();
      //         this.clearAll();
      //       } else {
      //         this.setState({
      //           searchrecords: records,
      //           searchTableSuccess: res,
      //           editformSuccess: res,
      //           loading: false,
      //         });
      //         toast.error("Drug could not be Added. ", {
      //           className: "toast-error"
      //         });
      //         this.clearMessage();
      //       }
      //     })
      //     .catch(() => { });
      // } else {
      //   axios
      //     .put(url, data, CONFIG)
      //     .then((updateDrugResponse) => {
      //       let updateResponse = updateDrugResponse.data;
      //       if (updateResponse.status === "1") {
      //         let addDrugSuccess = this.state.addDrugSuccess;
      //         addDrugSuccess = updateResponse.message;
      //         this.setState({ addDrugSuccess: addDrugSuccess });

              /** Updating the data table */
  //             let existingRecords = this.state.records;
  //             var index = existingRecords.findIndex(
  //               (item) => item.id === data.id
  //             );
  //             existingRecords.splice(index, 1, data);
  //             this.setState({ records: existingRecords });
  //              this.setState({ tableSuccess: updateResponse });
  //             this.setState({ editformSuccess: updateResponse });
  //             toast.success("The Drug details have been updated successfully.", {
  //               className: "toast-success"
  //             });
  //             this.clearMessage();
  //             this.clearAll();
  //           } else {
  //             this.setState({ tableSuccess: updateResponse });
  //             this.setState({ editformSuccess: updateResponse });
  //             toast.error("Drug could not be updated. ", {
  //               className: "toast-error"
  //             });
  //             this.clearMessage();
  //           }
  //           this.setState({ loading: false });
  //         })
  //         .catch(() => { });
  //     }
  //   }
  // }

//   addorupdateDrug() {
//     let url = this.state.drug_action === "Add" ? addPharmacyDrug : updatePharmacyDrug;
//     axios.defaults.headers.common["Authorization"] = `Bearer ${this.props.access_token}`;

//     let { drugData, errors } = this.state;
//     drugData.type = "pharmacydrug";
//     errors = Validation(drugData, errors);
//     this.setState({ errors: errors });

//     if (errors.formIsValid) {
//         this.setState({ loading: true });

//         let data = {};
//         data.user_id = this.props.userdata.id;
//         data.id = drugData.id;
//         data.drug_name = drugData.drug_name;
//         data.active_ingredients = drugData.active_ingredients;

//         let records = this.state.records;

//         if (this.state.drug_action === "Add") {
//             axios.post(url, data, CONFIG)
//                 .then((addDrugResponse) => {
//                     let res = addDrugResponse.data;
//                     if (res.status === "1") {
//                         let drug = {
//                             s_no: records.length + 1,
//                             drug_id: data.drug_id,
//                             id: res.data[0].id,
//                             drug_name: data.drug_name,
//                             active_ingredients: data.active_ingredients,
//                         };
//                         records.push(drug);
//                         this.setState({
//                             records: records,
//                             searchTableSuccess: res,
//                             loading: false,
//                             editformSuccess: res,
//                         });
//                         toast.success("The Drug details have been added successfully.", {
//                             className: "toast-success"
//                         });
//                         this.clearMessage();
//                         this.clearAll();
//                     } else {
//                         this.setState({
//                             searchrecords: records,
//                             searchTableSuccess: res,
//                             editformSuccess: res,
//                             loading: false,
//                         });
//                         toast.error("Drug could not be Added. ", {
//                             className: "toast-error"
//                         });
//                         this.clearMessage();
//                     }
//                 })
//                 .catch(() => { });
//         } else {
//             axios.put(url, data, CONFIG)
//                 .then((updateDrugResponse) => {
//                     let updateResponse = updateDrugResponse.data;
//                     if (updateResponse.status === "1") {
//                         let existingRecords = this.state.records;
//                         var index = existingRecords.findIndex((item) => item.id === data.id);
//                         existingRecords.splice(index, 1, { ...existingRecords[index], ...data });

                        
//                         existingRecords = existingRecords.map((record, idx) => ({
//                             ...record,
//                             s_no: idx + 1 
//                         }));

//                         this.setState({
//                             records: existingRecords,
//                             tableSuccess: updateResponse,
//                             editformSuccess: updateResponse,
//                         });
//                         toast.success("The Drug details have been updated successfully.", {
//                             className: "toast-success"
//                         });
//                         this.clearMessage();
//                         this.clearAll();
//                     } else {
//                         this.setState({ tableSuccess: updateResponse, editformSuccess: updateResponse });
//                         toast.error("Drug could not be updated. ", {
//                             className: "toast-error"
//                         });
//                         this.clearMessage();
//                     }
//                     this.setState({ loading: false });
//                 })
//                 .catch(() => { });
//         }
//     }
// }

  onDeleteClick(record) {
    this.setState({ addPopup: true, record: record });

  }

  cancelDelete() {
    this.setState({
      showDeleteConfirmPopup: !this.state.showDeleteConfirmPopup,
    });
  }

  deleteRecord(record) {
    let userId = record.id;
    this.setState({ loading: true });
    axios.defaults.headers.common[
      "Authorization"
    ] = `Bearer ${this.props.access_token}`;
    axios
      .delete(deletePharmacyDrug, { data: { id: userId } }, CONFIG)
      .then((res) => {
        let response = res.data;
        if (response.status === "1") {
          let records = this.state.records;
          const deleteIndex = records.map((item) => item.id).indexOf(record.id);
          records.splice(deleteIndex, 1);
          this.setState({ records });
        }
        this.setState({ addPopup: false, record: "", loading: false });
        this.setState({ tableSuccess: res.data });
        toast.error("The Drug detail has been deleted successfully.", {
          className: "toast-error"
        });
        this.clearMessage();
        this.clearAll();
        axios.defaults.headers.common[
          "Authorization"
        ] = `Bearer ${this.props.access_token}`;
        axios
          .post(getAllPharmacyDrugs, { user_id: this.props.userdata.id }, CONFIG)
          .then((list) => {
            let drugList = list.data.data;
            let drugDataArr = [];
            drugList.forEach((element, index) => {
              let drugData = {};
              drugData.s_no = index + 1;
              drugData.id = element.id;
              drugData.user_id = this.props.userdata.id;
              drugData.drug_id = element.drug_id;
              drugData.drug_name = element.drug_name;
              drugData.drug_type = element.drug_type;
              drugData.drug_category = element.drug_category;
              drugData.generic_name=element.generic_name;
              drugData.manufacturer = element.manufacturer;
              drugData.active_ingredients = element.active_ingredients;
              drugData.unit_of_measure = element.unit_of_measure;
              drugDataArr[index] = drugData;
            });
    
            this.setState({ records: drugDataArr });
          })
          .catch(() => { });
    
      })
      .catch(() => { });
  
  }
  clearMessage = () => {
    setTimeout(
      () =>
        this.setState({
          formSuccess: { message: "" },
          tableSuccess: { message: "" },
          searchTableSuccess: { message: "" },
          editformSuccess: { message: "" },
        }),
      5000
    );
  };
  clearAll=()=> {
    let drug_action = this.state.drug_action;
    drug_action = "Add";
    this.setState({ drug_action });
    let drugData = {};
    drugData.drug_id = "";
    drugData.drug_name = "";
    drugData.manufacturer = "";
    drugData.drug_category = "";
    drugData.generic_name="";
    drugData.drug_type = "";
    drugData.active_ingredients = "";
    drugData.unit_of_measure = "";
    let errors = {
      drug_id: "",
      drug_name: "",
      drug_type: "",
      drug_category: "",
      unit_of_measure: "",
    }
    let tableSuccess = {
      message: "",
      status: "",
    };
    let formSuccess = {
      message: "",
      status: "",
    };
    let editformSuccess = {
      message: "",
      status: "",
    };
    let searchTableSuccess = {
      message: "",
      status: "",
    }
    

    this.setState({ drugData, errors, tableSuccess, formSuccess, editformSuccess, searchTableSuccess, searchErrorMessage: "",searchrecords: [],search_action:false });
    

  }
  clearimport=()=>{
    this.setState({ file:"" });
  };
  searchandshowDrug() {
    let drugData = this.state.drugData;
    console.log(drugData);
    if (
      (drugData.drug_name === "" || null === drugData.drug_name) &&
      (drugData.drug_category === "" || null === drugData.drug_category) &&
      (drugData.drug_type === "" || null === drugData.drug_type) &&
      (drugData.unit_of_measure === "" || null === drugData.unit_of_measure) &&
      drugData.manufacturer === "" &&
      drugData.active_ingredients === "" &&
      drugData.generic_name===""
    ) {
      this.setState({
        searchErrorMessage:
          "Choose any one of the search filters other than Drug ID.",
      });
      return;
    } else {
      this.setState({
        searchErrorMessage: "",
      });
    }
    let data = {};
    data.drug_name = drugData.drug_name;
    data.drug_category = drugData.drug_category
      ? drugData.drug_category.label
      : "";
    data.drug_type = drugData.drug_type ? drugData.drug_type.label : "";
    data.manufacturer = drugData.manufacturer;
    data.active_ingredients = drugData.active_ingredients;
    data.generic_name=drugData.generic_name;
    data.unit_of_measure=drugData.unit_of_measure.label;
    data.type = "admin";
    data.user_id = this.props.userdata.id;
    axios.defaults.headers.common[
      "Authorization"
    ] = `Bearer ${this.props.access_token}`;
    this.setState({ loading: true }, () => {
      axios.post(searchDrug, data, CONFIG).then((searchres) => {
        this.setState({ loading: false });
        let result = searchres.data;
        let data = [];
        if (result.countOfRecords > 0) {
          let records = result.data;
          //  console.log(this.state.masterdrugmeasure[0]);
          records.forEach((element) => {
            console.log(element);
            console.log(element.drug_name);
            console.log(element.drug_category);
            console.log(element.unit_of_measure);
            data.push({
              drug_id: "",
              drug_name: element.drug_name,
              drug_name_hide: element.drug_name,
              drug_category: element.drug_category,
              unit_of_measure: element.unit_of_measure,
              drug_category_hide: element.drug_category,
              drug_type: element.drug_type,
              drug_type_hide: element.drug_type,
              generic_name:element.generic_name,
              manufacturer: element.manufacturer,
              active_ingredients: element.active_ingredients,
              id: element.id,
              drugid_error: "",
              drugcategory_error: "",
              drugtype_error: "",
              drugname_error: "",
              generic_name_error:"",
              manufacturer_error:"",
              active_incredients_error:"",
            });
          });

          this.setState({ searchrecords: data });
          this.setState({
            search_action: true,
          });
        } else {
          this.setState({ searchErrorMessage:"No Drug Found",searchrecords: [], search_action: true });
        }
      });
    });
  }
  onFileChange = event => {

    // Update the state
    this.setState({ file: event.target.files[0] });
    console.log(event.target.files[0]);
    readXlsxFile(event.target.files[0]).then((rows) => {
        console.log(rows);
        console.log("rows");
        this.setState({ drugData: rows });
        // `rows` is an array of rows
        // each row being an array of cells.
    })

};
onFileUpload = () => {

   if (this.state.drugData.length) {
      axios.post(pharmacydrugimport, {data: this.state.drugData,user_id:this.props.userdata.id}).then((result) => {
          console.log(result);
          this.setState({ formSuccess: result.data, file: "", drugData: [] })
          axios
          .post(getAllPharmacyDrugs, { user_id: this.props.userdata.id }, CONFIG)
          .then((list) => {
            let drugList = list.data.data;
            let drugDataArr = [];
            drugList.forEach((element, index) => {
              let drugData = {};
              drugData.s_no = index + 1;
              drugData.id = element.id;
              drugData.user_id = this.props.userdata.id;
              drugData.drug_id = element.drug_id;
              drugData.drug_name = element.drug_name;
              drugData.drug_type = element.drug_type;
              drugData.drug_category = element.drug_category;
              drugData.generic_name=element.generic_name;
              drugData.manufacturer = element.manufacturer;
              drugData.active_ingredients = element.active_ingredients;
              drugData.unit_of_measure = element.unit_of_measure;
              drugDataArr[index] = drugData;
            });
    
            this.setState({ records: drugDataArr });
          })
          .catch(() => { });
          this.clearMessage();
      });
  }

};
  render() {

    let ExpirePopupClose = () => {
      window.location.reload();
      this.setState({ showexpirePopup: true })
    };
    let ExpirePopupConfirm = () => {
      window.location.href = "/showsubscription";

    };
    let PopupClose = () => this.setState({ addPopup: false });
    let PopupConfirm = () => this.deleteRecord(this.state.record);
    let PopupHospitalClose = () => {
      this.setState({ hospitalpopup:true})
     
    };
    const {
      drugData,
      drugTypes,
      drugCategories,
      errors,
      loading,
      searchTableSuccess,
      editformSuccess,
      tableSuccess,
      searchErrorMessage,
      hospitaltimeout,
      formSuccess,
    } = this.state;
    const modalVar = this.state.showDeleteConfirmPopup;

    return (
      <div id="layout-wrapper">
        {/* <SideBarNew /> */}
        {/* <ExpirePopup
          show={!this.state.showexpirePopup}
          onHide={ExpirePopupClose}
          onConfirm={ExpirePopupConfirm}
          title={"Alert"}
          message={"Your current plan has been expired. Please activate new plan and try again"}
        /> */}
        <IdleTimeOutModal
          showModal={this.state.showModal}
          handleClose={this.handleClose}
          handleLogout={this.handleLogout}
        />

        <IdleTimer
          ref={ref => { this.idleTimer = ref }}
          element={document}
          onActive={this.onActive}
          onIdle={this.onIdle}
          onAction={this.onAction}
          debounce={250}
          timeout={hospitaltimeout} />

 {loading && <Dnaspinner />} 
{/* {loading && <LoadingHeartrate />} */}

        <div className="main-content bacfot">
          <div className="mainpage">
            <Header user_id={this.props.userdata.id} />
            <div className="main-box">
              <div className="sidemenu pr0">
              {this.props.userdata.user_type === "hospital" ? (
                    <BusinessUserSideBar />
                  ) : this.props.userdata.user_type === "pharmacy" ? (
                    <BusinessUserSideBar />
                  ) : (
                    <ClientSideBar />
                  )}
              </div>

              {
                                   (this.state.adminstatus !== "" && this.state.adminstatus === "Pending") ? (
                                        <div className="container-fluid">
                                                    <div className="checkout-tabs">
                                                        
                                    <div className="row">
                                        <div className="col-sm-12 pr0">
                                            <div className="card">
                                                <div className="card-body a-page-1-hight-right ">
                                                    {/* Admin not approved your account yet to view this page. Please contact the administrator to approve your account. */}
                                                    <Popupinfo
                                                     show={!this.state.hospitalpopup}
                                                     onHide={PopupHospitalClose}
                                                     title={"Alert!!"}
                                                      message={" Your Account is now waiting for our approval. Kindly contact the administrator to approve your request."}
                                                      />
                                               </div>

                                            </div>
                                        </div>
                                        </div>
                                        </div>

                                    </div>) :
           (

              <section className="main-body hospital-profilegap">
                <div className="container-fluid">
                  <div className="checkout-tabs">

                    <div className="col-sm-12">
                      <h4 className="font-weight-bold"> Drug List </h4>
                      <div className="row mt-4">

                        <div className="col-sm-12">
                          <div className="card ">
                            <div className="card-body ">
                              <div
                                className="tab-content"
                                id="v-pills-tabContent"
                              >
                                    <div className="float-right btn "> <DrugsExport pharmacy_id={this.props.userdata.id} records={this.state.records}/></div>
                              
                                <div
                                  className="tab-pane fade show active"
                                  id="v-pills-shipping"
                                  role="tabpanel"
                                  aria-labelledby="v-pills-shipping-tab"
                                >
                                  <div className="user-notification">
                                    <SpanField
                                      classname={
                                        "0" === tableSuccess.status
                                          ? "text-danger user-notification"
                                          : "text-success user-notification"
                                      }
                                      title={tableSuccess.message}
                                    />
                                  </div>
                                  <ReactDatatable
                                    className="table table-bordered table-striped kas  mobile_table"
                                    config={this.config}
                                    records={this.state.records}
                                    columns={this.columns}
                                  />
                                  <Popup
                                    show={this.state.addPopup}
                                    onHide={PopupClose}
                                    onConfirm={PopupConfirm}
                                    title={"Confirmation"}
                                    message={
                                      "Are you sure you want to delete this record ?"
                                    }
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="col-sm-12">
                                            <div className="card">
                                            <div className="card-header"> <div className="card-title">Import Drug</div> </div>
                                                <div className="card-body">
                                                    <div>
                                                      
                                                        <div className="user-notification">
                                                            <SpanField
                                                                classname={
                                                                    "0" === formSuccess.status
                                                                        ? "text-danger user-notification"
                                                                        : "text-success user-notification"
                                                                }
                                                                title={formSuccess.message}
                                                            />
                                                        </div>
                                                        <div className="form-group d-flex justify-content-center mg-btm5">
                                                                    <button
                                                                        ref="btn"
                                                                        href="patients-register"
                                                                        className="signupbtn abtn btdpml btn-margin"
                                                                        onClick={this.onFileUpload}>

                                                                        {loading ? (
                                                                            <LoadingSpinner title="Update" />
                                                                        ) : this.state.actions === "Update" ? (
                                                                            "Upload"
                                                                        ) : (
                                                                            "Upload"
                                                                        )}
                                                                    </button>
                                                                    <button
                                                                        href="patients-register"
                                                                        className="signupbtn abtn btdpml"
                                                                        onClick={this.clearimport}
                                                                    >
                                                                        Cancel
                                                                    </button>
                                                                </div>
                                                        <div className="float-right btn btn2 "> <DrugTemplate /></div>
                              
                                                        <div className="row">
                                                                
                                                            <div className="col-sm-4" >
                                                                <div className="custom-file text-left">
                                                                    
                                                                    <input accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel" type="file" onChange={this.onFileChange} name="file" className="custom-file-input" id="file" />
                                                                    <label className="custom-file-label" htmlFor="file">{this.state.file ? this.state.file.name : ""}</label>
                                                                    
                                                                    {/* <div className="form-group  mt-2">
                                                                    <button
                                                                        ref="btn"
                                                                        href="patients-register"
                                                                        className="signupbtn abtn btdpml btn-margin"
                                                                        onClick={this.onFileUpload}>

                                                                        {loading ? (
                                                                            <LoadingSpinner title="Update" />
                                                                        ) : this.state.actions === "Update" ? (
                                                                            "Upload"
                                                                        ) : (
                                                                            "Upload"
                                                                        )}
                                                                    </button>
                                                                    <button
                                                                        href="patients-register"
                                                                        className="signupbtn abtn btdpml"
                                                                        onClick={this.clearimport}
                                                                    >
                                                                        Cancel
                                                                    </button>
                                                                </div> */}
                                                                </div>
                                                             
                                                            </div>

                                                       
                                                           
                                                        </div>
                                                    </div>
                                                  {/*   <div className="form-group"><label className="control-label">{this.state.file ? this.state.file.name : ""}</label></div> */}
                                                </div>
                                            </div>
                                        </div> 
                        <div className="col-sm-12 pr0">
                          <div className="card m565">
                          <div className="card-header"> <div className="card-title"> {this.state.drug_action === "Add"
                                  ? "Add"
                                  : "Edit"}{" "}
                                Drug</div> </div>
                            <div className="card-body">
                              
                              <div className="user-notification-box text-center">
                                <SpanField
                                  classname={
                                    "0" === editformSuccess.status
                                      ? "text-danger user-notification"
                                      : "text-success user-notification"
                                  }
                                  title={editformSuccess.message}
                                />
                                <ToastContainer position="bottom-center" hideProgressBar={true} autoClose={2000} closeOnClick={false} pauseOnHover />

                              </div>
                              <div className="user-notification">
                                {searchErrorMessage ? (
                                  <div
                                    className="alert alert-danger"
                                    role="alert"
                                  >
                                    {searchErrorMessage}
                                  </div>
                                ) : (
                                  ""
                                )}
                              </div>
                              <div>

                                <hr className="rowline" />
                              </div>



                              <div className="row">
                              <div className="col-sm-6">
                                  <div className="frllftfull">
                                    <div className="form-group frllft mbbre">
                                    <Label title="Drug Name" isMandatory={true} /> 
                                    </div>

                                    <div className="form-group frlrit">
                                      <div className="position-relative">
                                        <div className="input-group">
                                         
                                          <InputField
                                            inputType={"text"}
                                            isMandatory={true}
                                            name={"drug_name"}
                                            controlFunc={this.handleInput.bind(
                                              this
                                            )}
                                            content={drugData.drug_name}
                                            placeholder={""}
                                            max={50}
                                          />
                                          {/* <Select maxMenuHeight={120}
                                            className="selectcls p-0"
                                            name="drug_name"
                                            isMandatory={true}
                                            value={drugData.drug_name}
                                            onChange={this.handleselectChange}
                                            options={masterdrugNames}
                                          /> */}

                                        </div>
                                        <SpanField
                                          classname="text-danger"
                                          title={errors.drug_name}
                                        />
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              {/*   <div className="col-sm-6">
                                  <div className="frllftfull">
                                    <div className="form-group frllft mbbre">
                                    <Label title="Drug ID" isMandatory={true} />
                                    </div>
                                    <div className="form-group frlrit">
                                      <InputField
                                        inputType={"text"}
                                        isMandatory={true}
                                        name={"drug_id"}
                                        controlFunc={this.handleInput.bind(
                                          this
                                        )}
                                        content={drugData.drug_id}
                                        placeholder={""}
                                        max={5}

                                      />
                                      <SpanField
                                        classname="text-danger"
                                        title={errors.drug_id}
                                      />
                                    </div>
                                  </div>
                                </div> */}
                                <div className="col-sm-6">
                                  <div className="frllftfull">
                                    <div className="form-group frllft mbbre">
                                    <Label title="Active Ingredients" isMandatory={true} /> 
                                    </div>
                                    <div className="form-group frlrit">
                                      <InputField
                                        inputType={"text"}
                                        name={"active_ingredients"}
                                        controlFunc={this.handleInput}
                                        content={drugData.active_ingredients}
                                        placeholder={""}
                                        max={50}
                                      />
                                      <SpanField
                                          classname="text-danger"
                                          title={errors.active_ingredients}
                                        />
                                    </div>
                                  </div>
                                </div>
                               {/*  <div className="col-sm-6">
                                  <div className="frllftfull">
                                    <div className="form-group frllft mbbre">
                                      <label>Drug Category</label>
                                    </div>
                                    <div className="form-group frlrit">
                                      <div className="position-relative">
                                        <div className="input-group">
                                          <div className="input-group-prepend">
                                            <span className="input-group-text inpico">
                                              <i className="fas fa-search"></i>
                                            </span>
                                          </div>
                                          <Select maxMenuHeight={120}
                                            className="selectcls p-0"
                                            name="drug_category"
                                            isMandatory={true}
                                            value={drugData.drug_category}
                                            onChange={this.handleselectChange}
                                            options={drugCategories}
                                          />
                                        </div>
                                        <SpanField
                                          classname="text-danger"
                                          title={errors.drug_category}
                                        />
                                      </div>
                                    </div>
                                  </div>
                                </div> */}
                              </div>

                              <div className="row">
                               

              {/*                   <div className="col-sm-6">
                                <div className="frllftfull">
                                    <div className="form-group frllft mbbre">
                                    <Label title="Manufacturer" isMandatory={true} /> 
                                    </div>
                                    <div className="form-group frlrit">
                                      <InputField
                                        inputType={"text"}
                                        name={"manufacturer"}
                                        controlFunc={this.handleInput}
                                        content={drugData.manufacturer}
                                        placeholder={""}
                                        max={200}
                                      />
                                      <SpanField
                                          classname="text-danger"
                                          title={errors.manufacturer}
                                        />
                                    </div>
                                  </div>
                            
                                </div> */}

                              </div>

                              <div className="row">

                              </div>

                              <div className="row">

                              </div>

                           {/*    <div className="row">

                              <div className="col-sm-6">
                                  <div className="frllftfull">
                                    <div className="form-group frllft mbbre">
                                    <Label title="Generic Name" isMandatory={true} />  
                                    </div>
                                    <div className="form-group frlrit">
                                      <InputField
                                        inputType={"text"}
                                        name={"generic_name"}
                                        controlFunc={this.handleInput}
                                        content={drugData.generic_name}
                                        placeholder={""}
                                        max={30}
                                      />
                                      <SpanField
                                          classname="text-danger"
                                          title={errors.generic_name}
                                        />
                                    </div>
                                    
                                  </div>
                                </div>
                                <div className="col-sm-6">
                                  <div className="frllftfull">
                                    <div className="form-group frllft mbbre">
                                    <Label title="Unit Of Measures" isMandatory={true} /> 
                                    </div>
                                    <div className="form-group frlrit">
                                      <div className="position-relative">
                                        <div className="input-group">
                                          <div className="input-group-prepend">
                                            <span className="input-group-text inpico">
                                              <i className="fas fa-search"></i>
                                            </span>
                                          </div>
                                          <Select maxMenuHeight={120}
                                            className="selectcls p-0"
                                            name="unit_of_measure"
                                            isMandatory={true}
                                            value={drugData.unit_of_measure}
                                            onChange={this.handleselectChange}
                                            options={this.state.masterdrugmeasure}
                                          />
                                        </div>
                                        <SpanField
                                          classname="text-danger"
                                          title={errors.unit_of_measure}
                                        />
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div> */}

                              <div className="row">
                               
                                <div className="col-sm-12 text-right">
                                  <button
                                    className="signupbtn abtn mr-2 phone-button"
                                    onClick={this.addorupdateDrug.bind(this)}
                                  >
                                    {" "}
                                    {this.state.drug_action === "Add"
                                      ? "Add"
                                      : "Update"}
                                  </button>
                                {/*   <button
                                    className="signupbtn abtn mr-2 phone-button" disabled={this.state.drug_action=="Edit"?true:false}
                                    onClick={this.searchandshowDrug.bind(
                                      this
                                    )}
                                  >
                                    Search
                                  </button> */}
                                  <button className="signupbtn abtn phone-button" align="left" onClick={this.clearAll}>
                                    Reset
                                  </button>
                                </div>
                                {" "}
                               
                                {""}
                                
                              </div>

                            </div>
                          </div>
                        </div>

                        {/* <div className="col-sm-6 pr0">
                          <div className=" card m565"> */}
                        {/* <div className="card-body">
                              <div>
                                <h5 className="regxs">Search Drug</h5>
                                <hr className="rowline" />
                              </div>
                              <div className="user-notification">
                                {searchErrorMessage ? (
                                  <div
                                    className="alert alert-danger"
                                    role="alert"
                                  >
                                    {searchErrorMessage}
                                  </div>
                                ) : (
                                  ""
                                )}
                              </div>
                              <div className="row">
                                <div className="col-sm-10">
                                  <div className="frllftfull">
                                    <div className="form-group frllft mbbre">
                                      <label>Drug Name</label>
                                    </div>

                                    <div className="form-group frlrit">
                                      <div className="position-relative">
                                        <div className="input-group">
                                          <div className="input-group-prepend">
                                            <span className="input-group-text inpico">
                                              <i className="fas fa-search"></i>
                                            </span>
                                          </div>
                                          <Select maxMenuHeight={120}
                                            isClearable={true}
                                            className="selectcls p-0"
                                            name="drug_name"
                                            isMandatory={true}
                                            value={searchData.drug_name}
                                            onChange={
                                              this.handlesearchselectChange
                                            }
                                            options={masterdrugNames}
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <div className="row">
                                <div className="col-sm-10">
                                  <div className="frllftfull">
                                    <div className="form-group frllft mbbre">
                                      <label>Drug Category</label>
                                    </div>
                                    <div className="form-group frlrit">
                                      <div className="position-relative">
                                        <div className="input-group">
                                          <div className="input-group-prepend">
                                            <span className="input-group-text inpico">
                                              <i className="fas fa-search"></i>
                                            </span>
                                          </div>
                                          <Select maxMenuHeight={120}
                                            isClearable={true}
                                            className="selectcls p-0"
                                            name="drug_category"
                                            isMandatory={true}
                                            value={searchData.drug_category}
                                            onChange={
                                              this.handlesearchselectChange
                                            }
                                            options={drugCategories}
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <div className="row">
                                <div className="col-sm-10">
                                  <div className="frllftfull">
                                    <div className="form-group frllft mbbre">
                                      <label>Drug Type</label>
                                    </div>
                                    <div className="form-group frlrit">
                                      <div className="position-relative">
                                        <div className="input-group">
                                          <div className="input-group-prepend">
                                            <span className="input-group-text inpico">
                                              <i className="fas fa-search"></i>
                                            </span>
                                          </div>
                                          <Select maxMenuHeight={120}
                                            isClearable={true}
                                            className="selectcls p-0"
                                            name="drug_type"
                                            isMandatory={true}
                                            value={searchData.drug_type}
                                            onChange={
                                              this.handlesearchselectChange
                                            }
                                            options={drugTypes}
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <div className="row">
                                <div className="col-sm-10">
                                  <div className="frllftfull">
                                    <div className="form-group frllft mbbre">
                                      <label>Manufacturer</label>
                                    </div>
                                    <div className="form-group frlrit">
                                      <InputField
                                        inputType={"text"}
                                        name={"manufacturer"}
                                        controlFunc={
                                          this.handlesearchinputChange
                                        }
                                        content={searchData.manufacturer}
                                        placeholder={""}
                                        max={50}
                                      />
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <div className="row">
                                <div className="col-sm-10">
                                  <div className="frllftfull">
                                    <div className="form-group frllft mbbre">
                                      <label>Active Ingredients</label>
                                    </div>
                                    <div className="form-group frlrit">
                                      <InputField
                                        inputType={"text"}
                                        name={"active_ingredients"}
                                        controlFunc={
                                          this.handlesearchinputChange
                                        }
                                        content={searchData.active_ingredients}
                                        placeholder={""}
                                        max={50}
                                      />
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <div className="row m-b-50">
                                <div className="col-sm-4"></div>
                                <div className="col-sm-3">
                                  <div className="form-group mb-0">
                                    <button
                                      className="signupbtn abtn btdpml"
                                      onClick={this.searchandshowDrug.bind(
                                        this
                                      )}
                                    >
                                      {/* {" "}
                                      {loading ? (
                                        <LoadingSpinner title="Search" />
                                      ) : (
                                        "Search"
                                      )} */}
                        {/* Search
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div> */}
                        {/* </div>
                        </div>  */}



                        <div
                          className="w100"
                          style={{
                            display: this.state.search_action
                              ? "block"
                              : "none",
                          }}
                        >
                          <div className="col-sm-12">
                            <div className="hmeclr bgligtrn">
                              <h5 className="fnsz hptd"> Search Result </h5>
                            </div>
                          </div>
                          <div className="col-sm-12">
                            <div className="card">
                              <div className="card-body">
                                <div
                                  className="tab-content"
                                  id="v-pills-tabContent"
                                >
                                  <div
                                    className="tab-pane fade show active"
                                    id="v-pills-shipping"
                                    role="tabpanel"
                                    aria-labelledby="v-pills-shipping-tab"
                                  >
                                    <div className="user-notification">
                                      <SpanField
                                        classname={
                                          "0" === searchTableSuccess.status
                                            ? "text-danger user-notification"
                                            : "text-success user-notification"
                                        }
                                        title={searchTableSuccess.message}
                                      />
                                    </div>
                                    <ReactDatatable
                                      className="table table-bordered table-striped kas  mobile_table"
                                      config={this.searchconfig}
                                      records={this.state.searchrecords}
                                      columns={this.searchcolumns}
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                         
                        </div>
                      </div>
                      {/* <Footerad /> */}
                    </div>
                    <Modal isOpen={modalVar}>
                      <ModalHeader>
                        <label className="text-center wdt100">
                          Confirmation
                        </label>
                      </ModalHeader>
                      <ModalBody>
                        <div className="col-sm-12">
                        Are you sure you want to delete this record ?
                        </div>
                        <div className="row">
                          <div className="col-sm-3">
                            <Button
                              color="success"
                              onClick={() => this.okDelete.bind(this)}
                            >
                              Ok
                            </Button>
                          </div>
                          <div className="col-sm-3">
                            <Button
                              color="danger"
                              onClick={this.cancelDelete.bind(this)}
                            >
                              Cancel
                            </Button>
                          </div>
                        </div>
                      </ModalBody>
                    </Modal>

                  </div>
                </div>

          
              </section>)}
              <FooterSection />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(PharmacyDrugslist);
function findWithAttr(array, attr, value) {
  for (var i = 0; i < array.length; i += 1) {
    if (array[i][attr] === value) {
      return i;
    }
  }
  return -1;
}
